import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskServiceModalEditRoute: InvariantJiraRoute = {
	name: 'servicedesk-service-modal-edit',
	path: '/jira/servicedesk/service-modal/:serviceAri',
};
